import * as React from 'react';

import * as style from './styles.css';

export const AdfoxBannerWrapper = ({ children }: React.PropsWithChildren) => {
  return <div className={style['container']}>{children}</div>;
};
